<agr-page-detail [pageTitle]="pageTitle$ | async" (backAction)="back()" [screenOnly]="true">
  <app-cycle-navigation class="screen-only"></app-cycle-navigation>
  <div class="cycle-item__container">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</agr-page-detail>
